import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./generalCSS/login.css";
import "./generalCSS/mobileverification.css";
import "./generalCSS/subscriptionplan.css";
import CryptoJS from 'crypto-js';
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  getSubscriptionPlanAction1,
  InsertPaymentDetailsAction,
  checkPlanPurchaseAction,
} from "../Action/propertyOwner.action";
import { getMMGJwt, facPayment } from "../Action/user.action";

import { Container, Row, Col, Button, Card, Form, Modal } from "react-bootstrap";
import config from "../coreFIles/config";
import { toast, Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import { IoIosArrowDown } from "react-icons/io";
import { CurrencyContext } from "../currencyConvertor/CurrencyContext";
const loginData = !Cookies.get("loginSuccessPropertyOwner")
  ? []
  : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

const Subscriptionplan = () => {
  const { currency, convertPrice } = useContext(CurrencyContext);
  const navigate = useNavigate();
  const [planData, setPlanData] = useState([]);
  const [planDataByUser, setPlanDataByUser] = useState([]);
  const [chooseplanDetails, setChoosePlanDetails] = useState({});
  const [clientSecret, setClientSecret] = useState("");
  const [isStep, setisStep] = useState(1);
  const [fygaroToken, setFygaroToken] = useState('');
  const _useLocation = useLocation();

  useEffect(() => {
    getSubscriptionplanByUserId();
  }, []);

  const getSubscriptionplanByUserId = async () => {
    getSubscriptionplan();
  };

  const getSubscriptionplan = async (subcribedData, value) => {
    let res = await getSubscriptionPlanAction1();
    if (res.success) {
      let planData;
      if (value) {
        planData = res.data.filter((item) => item.validity == value);
      } else {
        planData = res.data;
      }

      setPlanData(
        planData
          .filter((item) => item.amount == 0 || item.validity == 1)
          .sort((a, b) => a.amount - b.amount)
      );

    }
  };

  const getSubscriptionplanAPI = async (subcribedData) => {
    let res = await getSubscriptionPlanAction1();
    if (res.success) {
      if (subcribedData) {
        setPlanData(res.data.filter((item) => item.validity == subcribedData));
      } else {
        setPlanData(res.data.filter((item) => item.validity == 1));
      }
    }
  };

  function generateRandomString(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from({ length }, () =>
      characters.charAt(Math.floor(Math.random() * characters.length))
    ).join("");
  }

  const choosePlan = async (data) => {
    let res = await checkPlanPurchaseAction({ id: data.id });

    if (res.success) {
      if (data.amount > 0) {
        setChoosePlanDetails(data);
        getFygaroPayloadAPI(data)
        setisStep(2);
      } else {
        let arr = {
          subscriptionId: data.id,
          orderId: generateRandomString(16),
          cardNumber: "",
          receiptUrl: "",
          payerId: "",
          paymentMode: 3, // 3 free
        };
        let result = await InsertPaymentDetailsAction(arr);
        if (result.success) {
          toast.success(result.msg);
          setTimeout(() => {
            navigate(`${config.baseUrl}staffdashboard/getstarted`);
          }, 2000);
        } else {
          toast.error(result.msg);
        }
      }
    } else {
      toast.error(res.msg);
    }
  };

  const backBtn = async () => {
    setisStep(1);
  };

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>    PAYPAL PAYMENT  START   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: chooseplanDetails.description,
            amount: {
              currency_code: "USD",
              value: chooseplanDetails.amount - (chooseplanDetails.amount * chooseplanDetails.discount / 100),
            },
          },
        ],
      })
      .then((orderID) => {
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(async function (res) {
      if (res.status == "COMPLETED") {
        let arr = {
          subscriptionId: chooseplanDetails.id,
          orderId: res.id,
          cardNumber: "",
          receiptUrl: res.links[0].href,
          payerId: res.payer.payer_id,
          paymentMode: 1, // 1-Paypal
        };

        let result = await InsertPaymentDetailsAction(arr);
        if (result.success) {
          toast.success(result.msg);
          setTimeout(() => {
            navigate(`${config.baseUrl}staffdashboard/getstarted`);
          }, 2000);
        } else {
          toast.error(result.msg);
        }
      } else {
        toast.error(
          "Something went wrong with your payment. Please try again after some time"
        );
      }
    });
  };

  const onError = (data, actions) => {
    toast.error(
      "Something went wrong with your payment. Please try again after some time"
    );
  };

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>    PAYPAL PAYMENT END  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  const handleBack = () => {
    console.log(_useLocation.state);
    if (_useLocation.state == "profile") {
      navigate(`${config.baseUrl}staffdashboard/profile#subscription`);
    } else {
      navigate(`${config.baseUrl}`);
    }
  };

  const disableStripe = () => {
    setClientSecret("");
  };

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>   Get fygaro JWT token >>>>>>>>>>>>>>>>>>>>>>>>>>>>.

  const getFygaroPayloadAPI = async (data) => {
    const encryptionKey = config.fygaroJWTEncryptionKey;
    let fygaroPayload = {
      subscriptionId: data.id,
      type: 3
    };
    console.log('fygaroPayload', fygaroPayload);
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(fygaroPayload),
      encryptionKey
    ).toString();

    let jwtReceived = await getMMGJwt({ jwt: encryptedPayload });
    if (jwtReceived.success) {
      setFygaroToken(jwtReceived.data);
    }
  };

  //----------------|| FAC PAYMENT ||----------------//

  const [Facshow, setFacShow] = useState(false);
  const [checkoutForm, setCheckoutForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    amount: "",
  });

  const [emptyFields, setEmptyFields] = useState([]);
  const handleFacClose = () => {
    setCheckoutForm({})
    setFacShow(false)
    setEmptyFields([])
  };
  const handleFacShow = () => setFacShow(true);

  const handleFACChange = (e) => {
    const { id, value } = e.target;
    setCheckoutForm({ ...checkoutForm, [id]: value });

    if (emptyFields.includes(id)) {
      setEmptyFields(emptyFields.filter((field) => field !== id));
    }
  };

  const handleFACPayment = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "cardholderName", "cardNumber", "expiryDate", "cvv"];

    const missingFields = requiredFields.filter(
      (field) => !checkoutForm[field] || checkoutForm[field].trim() === ""
    );

    if (missingFields.length > 0) {
      setEmptyFields(missingFields);
      return;
    }
    try {
      let arr = {
        subscriptionId: chooseplanDetails.id,
        paymentMode: 3, // FAC
        bookingFor: 3, // 3 for subscription
        userId: loginData?.id,
        checkOutDetails: checkoutForm,
        amount: chooseplanDetails.amount,
      };



      let res = await facPayment(arr);
      if (res.data && res.data.RedirectData) {
        setCheckoutForm({});
        setFacShow(false);
        setEmptyFields([]);
        const redirectHTML = res.data.RedirectData;

        const blob = new Blob([redirectHTML], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        // Open in the same window/tab
        window.location.href = url;
      } else {
        alert("No redirect data received for 3DS authentication.");
      }
    } catch (error) {
      console.error("Error during FAC payment:", error);
      alert("Payment initiation failed.");
    }
  };

  return (
    <>
      <section className="login-section pt-5 pb-5 overflow-hidden vh-80">
        <Container>
          <Toaster />

          {isStep == 1 ? (
            <Row className="justify-content-center ">
              <Col xl={12} lg={12}>
                <div className="login-container">
                  <div className="login-form">
                    <div className="login-logo">
                      <Link to={`${config.baseUrl}`} className="mb-4">
                        <img src="assets/images/logo/logo.webp" alt="logo" />
                      </Link>
                      <div className="py-3">
                        <Row className="align-items-center">
                          <Col xl={2} lg={2} sm={2}>
                            <div className="back-btn mb-4">
                              <button
                                color="#000"
                                onClick={handleBack}
                                className="border-1 rounded-1 border-secondary h-auto arrow_left btn btn-default text-nowrap"
                                sx={{ mr: 1, color: "#000" }}
                              >
                                <img
                                  src="assets/images/icon/right_arrow.svg"
                                  width="7px"
                                />
                              </button>
                              &nbsp;
                             Back
                            </div>
                          </Col>
                          <Col xl={8} lg={8} sm={8}>
                            <div className="text-center">
                              <h3 className="mb-4 position-relative">
                                <b>CHOOSE A SUBSCRIPTION PLAN</b>
                              </h3>
                            </div>
                          </Col>
                          <Col xl={2}>
                            <div className="position-relative mb-4">
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  planDataByUser.length == 0
                                    ? getSubscriptionplanAPI(e.target.value)
                                    : getSubscriptionplan(
                                      planDataByUser,
                                      e.target.value
                                    )
                                }
                              >
                                <option value="1">1 Month</option>
                                <option value="6">6 Months</option>
                                <option value="12">1 Year</option>
                              </select>
                              <IoIosArrowDown
                                className="position-absolute"
                                style={{ top: "14px", right: "12px" }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12}>
                <div className="subscriptionplan">
                  <Row>
                    {planData.length === 0 ? (
                      <div
                        className="py-5 mt-5"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          src="assets/images/listing_img.svg"
                          width={`220px`}
                        />
                        <h6 className="text-center mt-3">No Data Found!!</h6>
                      </div>
                    ) : (
                      planData.map((item) => (
                        <Col xl={4} lg={4} className="mb-4">
                          <Card>
                            <div className="d-flex align-items-center">
                              <Card.Img
                                variant="top"
                                src="assets/images/plana.png"
                                width="60px"
                                className="me-2"
                              />
                              <h5 className="mb-0">
                                <b>{item.subscriptionType}</b> ({item.name}){" "}
                              </h5>
                            </div>
                            <Card.Body>
                              <p>{item.description}</p>
                              <div class="price-container">
                                <Row className="align-items-center pb-3">

                                  {item.discount > 0 ? (
                                    <Col xs="auto">
                                      <h3>
                                        <span style={{ textDecoration: "line-through", color: "#888", marginRight: "10px", fontSize: "18px" }}>
                                          {convertPrice(item.amount)} {}
                                        </span>
                                        <b>
                                          {convertPrice(item.amount - (item.amount * item.discount / 100))} {currency}
                                        </b>
                                      </h3>
                                    </Col>
                                  ) : (
                                    <Col xs="auto">
                                      <h3>
                                        <b>{convertPrice(item.amount)} {currency}</b>
                                      </h3>
                                    </Col>
                                  )}
                                  <Col xs="auto" className="ps-0">
                                    <span style={{ marginLeft: "0px" }}>
                                      / {item.validity} {item.validity == 1 ? "Month" : "Months"}
                                    </span>
                                  </Col>
                                </Row>
                              </div>


                              <Card.Text>
                                <h6>
                                  <b>What’s included</b>
                                </h6>
                                <ul>
                                  {item.IncludedDetails &&
                                    item.IncludedDetails.map((item1) => (
                                      <li>
                                        <img
                                          src="assets/images/icon/check_circle.svg"
                                          className="me-1"
                                        />
                                        {item1?.name}
                                      </li>
                                    ))}
                                </ul>
                              </Card.Text>

                              {loginData?.id ? (
                                <Button
                                  disabled={!item.isSubscribed ? false : true}
                                  variant="primary"
                                  className="w-100 rounded-1 mt-3"
                                  onClick={() => choosePlan(item)}
                                >
                                  {!item.isSubscribed
                                    ? "Get started"
                                    : "Subscribed"}{" "}
                                </Button>
                              ) : (
                                <Link to={`${config.baseUrl}login`}>
                                  <Button
                                    variant="primary"
                                    className="w-100 rounded-1 mt-3"
                                  >
                                    Get started
                                  </Button>
                                </Link>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))
                    )}
                  </Row>
                </div>
              </Col>
            </Row>
          ) : (
            <Row className="justify-content-center ">
              <Col xl={12} lg={12}>
                <div className="login-container">
                  <div className="login-form">
                    <div className="login-logo ">
                      <Link to={`${config.baseUrl}`} className="">
                        <img
                          src="assets/images/logo/logo.webp"
                          alt="logo"
                          className=""
                        />
                      </Link>
                      <div className="pt-4">
                        <Row className="align-items-center">
                          <Col xl={2} lg={2} sm={2}>
                            <div className="back-btn mb-4">
                              <button
                                onClick={backBtn}
                                className="border-1 rounded-1 border-secondary h-auto arrow_left btn btn-default"
                              >
                                <img
                                  src="assets/images/icon/right_arrow.svg"
                                  width="7px"
                                />
                              </button>
                              &nbsp; Back
                            </div>
                          </Col>
                          <Col xl={8} lg={8} sm={8}>
                            <div className="text-center">
                              <h3 className="mb-4 position-relative">
                                <b>PLAN DETAILS</b>
                              </h3>
                            </div>
                          </Col>
                          <Col xl={2}></Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xl={12} lg={12}>
                <div className="subscriptionplanDetails">
                  <Row>
                    <Col xl={3} lg={3} className="mb-4"></Col>
                    <Col xl={6} lg={6} className="mb-4">
                      <Card>
                        <div className="d-flex align-items-center">
                          <Card.Img
                            variant="top"
                            src="assets/images/plana.png"
                            width="60px"
                            className="me-2"
                          />
                          <h5 className="mb-0">
                            <b>{chooseplanDetails.subscriptionType}</b> (
                            {chooseplanDetails.name}){" "}
                          </h5>
                        </div>
                        <Card.Body className="pb-0">
                          <p>{chooseplanDetails.description} </p>
                          <div className="d-flex align-items-center pb-3">
                            <h2>
                              <b>{convertPrice(chooseplanDetails.amount - (chooseplanDetails.amount * chooseplanDetails.discount / 100))} {currency}</b>
                            </h2>
                            <span>
                              / {chooseplanDetails.validity}{" "}
                              {chooseplanDetails.validity == 1
                                ? "Month"
                                : "Months"}
                            </span>
                          </div>
                          <Card.Text>
                            <h6>
                              <b>What’s included</b>
                            </h6>
                            <ul>
                              {chooseplanDetails.IncludedDetails &&
                                chooseplanDetails.IncludedDetails.map(
                                  (data) => (
                                    <li>
                                      <img
                                        src="assets/images/icon/check_circle.svg"
                                        className="me-1"
                                      />
                                      {data?.name}
                                    </li>
                                  )
                                )}
                            </ul>
                          </Card.Text>

                          <PayPalScriptProvider
                            options={{ "client-id": config.CLIENT_ID }}
                            className="pglk"
                          >
                            <PayPalButtons
                              style={{ layout: "vertical" }}
                              className="paypal-buttons"
                              onClick={disableStripe}
                              createOrder={createOrder}
                              onApprove={onApprove}
                              onError={onError}
                              fundingSource={FUNDING.PAYPAL}
                            />
                          </PayPalScriptProvider>

                          <br />

                          {/*<button
                            style={{ backgroundColor: '#007bff', color: 'white' }}
                            className="d-flex align-items-center fw-bold justify-content-center btn w-100 mt-2"
                            onClick={handleFacShow}
                          >
                            Credit / Debit Card
                          </button>*/}


                          {/* <button className="btn paypal-button w-100 mt-2" onClick={callFygaro}>Fygaro</button> */}

                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xl={3} lg={3} className="mb-4"></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
        </Container>
        <Modal show={Facshow} onHide={handleFacClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title className="fw-semibold lh-1"><div>Checkout form</div> <span className="x-small h5">Please fill out the form below to complete your purchase.</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="cardholderName">
                    <Form.Label>Cardholder Name</Form.Label>
                    <Form.Control type="text"
                      placeholder="Enter name"
                      id="cardholderName"
                      value={checkoutForm.cardholderName}
                      onChange={handleFACChange}
                      style={{ borderColor: emptyFields.includes("cardholderName") ? "red" : "" }} />

                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="cardNumber">
                    <Form.Label>Card Number</Form.Label>
                    <Form.Control type="text"
                      placeholder="XXXX-XXXX-XXXX-XXXX"
                      id="cardNumber"
                      onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                      value={checkoutForm.cardNumber}
                      onChange={handleFACChange}
                      style={{ borderColor: emptyFields.includes("cardNumber") ? "red" : "" }}
                    />

                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group controlId="expiryDate">
                    <Form.Label>Expiration Date (YYMM)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="YY / MM"
                      id="expiryDate"
                      onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                      value={checkoutForm.expiryDate}
                      onChange={handleFACChange}
                      style={{ borderColor: emptyFields.includes("expiryDate") ? "red" : "" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="cvv">
                    <Form.Label>Security Code (CVV2)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="XXX"
                      id="cvv"
                      onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }}
                      value={checkoutForm.cvv}
                      onChange={handleFACChange}
                      style={{ borderColor: emptyFields.includes("cvv") ? "red" : "" }} />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="amount">
                    <Form.Label>Amount to pay</Form.Label>
                    <Form.Control
                      type="Number"
                      placeholder="e.g. 100.00 USD"
                      id="amount"
                      value={parseFloat(chooseplanDetails.amount) > 0 ? parseFloat(chooseplanDetails.amount).toFixed(2) : ""}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="button" className="w-100" onClick={handleFACPayment}>
                Confirm Payment
              </Button>

              <div className="text-center mt-4">
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" height="30" className="mx-2" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="MasterCard" height="30" className="mx-2" />
                <img src="images/american_exp.webp" alt="AMEX" height="30" className="mx-2" />
              </div>

              <div className="text-center mt-2 text-muted" style={{ fontSize: '14px' }}>
                <p>
                  POWERED BY <img src="images/Powertranz-Logo.png" alt="PowerTranz" style={{ height: '23px', verticalAlign: 'middle' }} />
                </p>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default Subscriptionplan;
